<h2 mat-dialog-title class="cart-header">
    <span class="title-large">{{ 'products.ui.carrello' | transloco }}</span>

    <button
        mat-icon-button
        type="button"
        [attr.aria-label]="'products.ui.chiudiCarrello' | transloco"
        (click)="onClose()"
    >
        <i class="fa-regular fa-xmark"></i>
    </button>
</h2>

<mat-dialog-content class="cart-content">
    @if (rows().length === 0) {
        <div class="cart-empty">
            <span class="body-medium">{{ 'products.ui.ilCarrelloEVuoto' | transloco }}</span>
        </div>
    } @else {
        @for (row of rows(); track row.id) {
            <div class="cart-row">
                <div class="cart-row-header">
                    <div class="cart-row-product">
                        <span class="body-medium emphasized cart-row-name">{{ row.nomeProdotto }}</span>
                        <span class="body-small">@if (row.sku) { {{ row.sku }} - }{{ row.nomeImballo ?? '-' }} - {{ row.unitaFatturabile }} {{ row.unitaMisura }}</span>
                    </div>

                    <div class="quantity-stepper">
                        <button
                            matButton="tonal"
                            [attr.aria-label]="'products.ui.rimuoviRiga' | transloco"
                            class="stepper-button"
                            (click)="remove(row)"
                        >
                            <i class="fa-regular fa-trash-can"></i>
                        </button>

                        @if (row.quantita > 1) {
                            <button
                                matButton="tonal"
                                [attr.aria-label]="'products.ui.diminuisciQuantita' | transloco"
                                class="stepper-button"
                                (click)="decrement(row)"
                            >
                                <i class="fa-regular fa-minus"></i>
                            </button>
                        }

                        <span class="body-medium emphasized quantity-value">{{ row.quantita }}</span>

                        <button
                            matButton="tonal"
                            [attr.aria-label]="'products.ui.aumentaQuantita' | transloco"
                            class="stepper-button"
                            (click)="increment(row)"
                        >
                            <i class="fa-regular fa-plus"></i>
                        </button>
                    </div>
                </div>

                <div class="cart-row-detail">
                    <span class="body-medium cart-row-label">{{ 'products.ui.prezzoUnitario' | transloco }}</span>
                    <span class="body-medium cart-row-value">
                        {{ row.prezzo | translocoCurrency: 'symbol' : { minimumFractionDigits: 4, maximumFractionDigits: 4 } }}/{{ row.unitaMisura }}
                        @if (!row.prezzoBloccato) {
                            <button mat-icon-button type="button" [attr.aria-label]="'products.ui.modificaPrezzo' | transloco" class="edit-price-button" (click)="editPrice(row)">
                                <i class="fa-regular fa-pen"></i>
                            </button>
                        }
                    </span>
                </div>

                @if (row.percScontoDerivato) {
                    <div class="cart-row-detail">
                        <span class="body-medium cart-row-label">{{ 'products.ui.sconto' | transloco }}</span>
                        <span class="body-medium cart-row-value">{{ row.percScontoDerivato | translocoDecimal: { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}%</span>
                    </div>
                }

                <div class="cart-row-detail">
                    <span class="body-medium cart-row-label">{{ 'products.ui.subtotale' | transloco }}</span>
                    <span class="body-medium cart-row-value">
                        {{ row.imponibile | translocoCurrency: 'symbol' : { minimumFractionDigits: 4, maximumFractionDigits: 4 } }}
                    </span>
                </div>

                @if (row.provvigioneDisponibile) {
                    <div class="cart-row-detail">
                        <span class="body-medium cart-row-label">{{ 'products.ui.provvigioneAgente' | transloco }}</span>
                        <span class="body-medium cart-row-value">{{ row.percProvvigione }}%</span>
                    </div>

                    <div class="cart-row-detail">
                        <span class="body-medium cart-row-label">{{ 'products.ui.importo' | transloco }}</span>
                        <span class="body-medium cart-row-value">
                            {{ row.provvigione | translocoCurrency: 'symbol' : { minimumFractionDigits: 4, maximumFractionDigits: 4 } }}
                        </span>
                    </div>
                }
            </div>

            <mat-divider></mat-divider>
        }
    }
</mat-dialog-content>

@if (rows().length > 0) {
    <div class="cart-summary">
        <div class="cart-summary-row">
            <span class="body-medium emphasized">{{ 'products.ui.subtotale' | transloco }}</span>
            <span class="body-medium emphasized">
                {{ cart()?.totaleImponibile ?? 0 | translocoCurrency: 'symbol' : { minimumFractionDigits: 4, maximumFractionDigits: 4 } }}
            </span>
        </div>

        <div class="cart-summary-row">
            <span class="body-small">CONOU</span>
            <span class="body-small">
                {{ cart()?.totaleConou ?? 0 | translocoCurrency: 'symbol' : { minimumFractionDigits: 4, maximumFractionDigits: 4 } }}
            </span>
        </div>

        <div class="cart-summary-row">
            <span class="title-large">{{ 'products.ui.totale' | transloco }}</span>
            <span class="title-large">
                @if (cart()?.totale != null) {
                    {{ cart()?.totale | translocoCurrency: 'symbol' : { minimumFractionDigits: 4, maximumFractionDigits: 4 } }}
                } @else {
                    -
                }
            </span>
        </div>

        @if (cart()?.totaleProvvigione != null) {
            <div class="cart-summary-row">
                <span class="body-small">{{ 'products.ui.totProvvigioniAgente' | transloco }}</span>
                <span class="body-small">
                    {{ cart()!.totaleProvvigione | translocoCurrency: 'symbol' : { minimumFractionDigits: 4, maximumFractionDigits: 4 } }}
                </span>
            </div>
        }

        <div class="cart-summary-actions">
            <button matButton="outlined" type="button" (click)="clearCart()">{{ 'products.ui.svuotaCarrello' | transloco }}</button>
            @if (showProposal) {
                <button matButton="filled" type="button" (click)="goToProposal()">{{ 'products.ui.vaiAProposta' | transloco }}</button>
            }
        </div>
    </div>
}
